/* global navigator window*/

import React from 'react';
import PropTypes from 'prop-types';
import setLoginModalState from 'Actions/setLoginModalState';
import { connect } from 'react-redux';
import NewIconButton from 'Components/ThematicNewIconButton/ThematicNewIconButton';

import { withConfig } from 'HOCs/withConfig/withConfig';
import SocialLink from './SocialLink';
import { compose } from 'redux';
import css from './ShareButton.scss';
import getSocials from './socials.APP_TARGET';
import { SHARE_BUTTON_CONSTANTS } from './Constants';
import withTrack from 'HOCs/withTrack/withTrack';
import { FormattedMessage as Translation } from 'react-intl';
import setToastMessageState from 'Actions/setToastMessageState';
import { TRANSLATIONS } from 'Constants/translations';
import { openSocialLink } from './util';

const TOAST_EXPIRATION_TIME = 5000;

export class ShareButton extends React.PureComponent {
    static propTypes = {
        path: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        description: PropTypes.string,
        itemId: PropTypes.string.isRequired,
        globalsConfig: PropTypes.object.isRequired,
        track: PropTypes.func.isRequired,
        getTrackingInfo: PropTypes.func.isRequired,
        color: PropTypes.string,
        size: PropTypes.number,
        setToastMessageState: PropTypes.func
    };

    componentDidMount() {
        if (typeof document !== 'undefined') {
            document.addEventListener('click', this.checkGlobalClick, true);
        }
    }

    componentWillUnmount() {
        if (typeof document !== 'undefined') {
            document.removeEventListener('click', this.checkGlobalClick, true);
        }
    }

    input = React.createRef();

    onCopyToClipboard = () => {
        this.props.setToastMessageState({ isOpen: true, message: <Translation id={ TRANSLATIONS.copiedToClipboard } />, expiration: TOAST_EXPIRATION_TIME });
        navigator.clipboard.writeText(document.location.href);
    };

    shareEmail = ev => {
        ev.stopPropagation();
        const emailLink = `${SHARE_BUTTON_CONSTANTS.EMAIL_LINK}${document.location.href}`;

        window.location.href = emailLink;
    };

    state = {
        description: '',
        showSocialLinks: false
    };

    getContent = () => {
        const socials = getSocials(this.props.globalsConfig.get('socials'));

        if (!this.state.showSocialLinks) {
            return null;
        }
        return (
            <React.Fragment>
                <div ref={ socialContainer => {
                    this.socialContainer = socialContainer;
                } }
                className={ css.socialContainer }>
                    <div className={ css.arrow } />
                    { socials.map((social, i) => {
                        return (
                            <SocialLink
                                key={ i }
                                social={ social }
                                text={ this.props.title }
                                path={ this.props.path }
                                itemId={ this.props.itemId }
                            />
                        );
                    })
                    }
                </div>
            </React.Fragment>
        );
    };

    openSocialLinks = () => {
        this.setState({ showSocialLinks: true });
    };

    closeSocialLinks = () => {
        this.setState({ showSocialLinks: false });
    };

    checkGlobalClick = e => {
        const target = e.target;
        const targetParent = e.target.parentElement;

        if (targetParent.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_AUT_ID) === SHARE_BUTTON_CONSTANTS.LINK || targetParent.parentElement.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_AUT_ID) === SHARE_BUTTON_CONSTANTS.LINK || target.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_AUT_ID) === SHARE_BUTTON_CONSTANTS.LINK_WRAPPER) {
            this.closeSocialLinks();
            this.onCopyToClipboard();
        }
        else if (targetParent.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_AUT_ID) === SHARE_BUTTON_CONSTANTS.EMAIL || targetParent.parentElement.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_AUT_ID) === SHARE_BUTTON_CONSTANTS.EMAIL || target.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_AUT_ID) === SHARE_BUTTON_CONSTANTS.EMAIL_WRAPPER) {
            this.closeSocialLinks();
            this.shareEmail(e);
        }
        else if (targetParent.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_AUT_ID) === SHARE_BUTTON_CONSTANTS.SOCIAL || (targetParent.parentElement.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_AUT_ID) === SHARE_BUTTON_CONSTANTS.SOCIAL || SHARE_BUTTON_CONSTANTS.SOCIAL_WRAPPER) || target.getAttribute(SHARE_BUTTON_CONSTANTS.DATA_AUT_ID) === SHARE_BUTTON_CONSTANTS.SOCIAL_WRAPPER) {
            this.closeSocialLinks();
            openSocialLink(target, targetParent);
        }
        else if (this.state.showSocialLinks && target !== this.socialContainer && targetParent !== this.socialContainer) {
            e.preventDefault();
            e.stopPropagation();
            this.closeSocialLinks();
        }
    };

    onClickShare = ev => {
        ev.stopPropagation();
        this.props.track('social_item_share', this.props.getTrackingInfo());
        if (navigator.share) {
            navigator.share({
                title: this.props.title,
                text: this.props.description,
                url: this.props.globalsConfig.get('host') + this.props.path
            })
                .catch(() => {
                    this.openSocialLinks();
                });
        }
        else {
            this.openSocialLinks();
        }
    };

    render() {
        return (
            <React.Fragment>
                <NewIconButton
                    name="Share"
                    icon="shareIt"
                    onClick={ this.onClickShare }
                    data-aut-id="btnShare"
                    color={ this.props.color }
                    size={ this.props.size }
                />
                { this.getContent() }
            </React.Fragment>
        );
    }
}

export const mapDispatchToProps = dispatch => {
    return {
        setLoginModalState: state => dispatch(setLoginModalState(state)),
        setToastMessageState: state => dispatch(setToastMessageState(state))
    };
};

export default compose(
    withTrack,
    withConfig('globalsConfig'),
    connect(null, mapDispatchToProps)
)(ShareButton);
